export default "__VITE_ASSET__6WTJ4qXQ__"